/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import dayjs from 'dayjs';

export interface TimeObj {
  hours: number;
  minutes: number;
  str: string;
}

/**
 * targetRate주의 요일 리스트를 반환
 * @param date
 * @returns
 */
export function getWeekData(date?: Date | dayjs.Dayjs | string): dayjs.Dayjs[] {
  const targetDate = date ? dayjs(date) : dayjs();
  const dayOfWeek = targetDate.day(); // 0 (Sunday) to 6 (Saturday)
  const firstDay = targetDate.subtract(dayOfWeek, 'day');

  return Array.from({ length: 7 }).map((_, index) =>
    dayjs(firstDay).add(index, 'day')
  );
}

/**
 * 오전6시 ~ 밤12시 사이의 30분 간격의 dayjs 리스트를 반환
 * @returns
 */
export function generateTimeBlocks() {
  let isDone = false;
  const start = dayjs().set('hour', 6).set('minute', 0);
  const intervalMinute = 30;
  const list: TimeObj[] = [];
  let date = dayjs(start);

  while (!isDone) {
    list.push({
      hours: dayjs(date).get('hour'),
      minutes: dayjs(date).get('minutes'),
      str: dayjs(date).format('HHmm')
    });
    date = dayjs(date).add(intervalMinute, 'minute');

    if (date.get('hour') === 0 && date.get('minute') !== 0) {
      isDone = true;
    }
  }

  return list;
}

/**
 * 년월일이 같은지 반환 (includeTime=true면 시간까지 같은지 확인)
 * @param date1
 * @param date2
 * @param includeTime
 * @returns
 */
export function getIsSameDate(
  date1: dayjs.Dayjs,
  date2: dayjs.Dayjs,
  includeTime?: boolean
) {
  const format = includeTime ? 'YYYYMMDDHHmm' : 'YYYYMMDD';
  return date1.format(format) === date2.format(format);
}

/**
 * 시간기반 id 반환 (YYYYMMDDHHmm)
 * @param date
 * @returns
 */
export function getIdByDate(date: ScheduleDate, includeTime = true) {
  if (includeTime) {
    return dayjs(date).format('YYYYMMDDHHmm');
  }

  return dayjs(date).format('YYYYMMDD');
}

/**
 * 현재 시간의 위치 기준으로 indicator위치값 반환
 * @param currentTime
 * @returns
 */
export function getTimeIndicatorPos(currentTime: dayjs.Dayjs = dayjs()) {
  const HOUR_HEIGHT_PX = 68;

  // 현재 시간의 시와 분을 가져옵니다.
  const currentHour = currentTime.hour() - 6;
  const currentMinute = currentTime.minute();

  if (currentHour < 0) {
    return -1;
  }

  const minuteFraction = currentMinute / 60;
  const position = (currentHour + minuteFraction) * HOUR_HEIGHT_PX;

  return position;
}
